import { render } from "./GlobalLocalNewsForm.vue?vue&type=template&id=6ece54f6"
import script from "./GlobalLocalNewsForm.vue?vue&type=script&lang=js"
export * from "./GlobalLocalNewsForm.vue?vue&type=script&lang=js"

import "./GlobalLocalNewsForm.vue?vue&type=style&index=0&id=6ece54f6&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__